var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{class:_vm.figureClass,style:(_vm.figureStyle),attrs:{"data-aspect":_vm.orderAsprect}},[_c('img',{ref:"picture",style:(_vm.imgStyle),attrs:{"src":_vm.src,"data-aspect":_vm.naturalAsprect},on:{"error":_vm.onLoadImageError}})])}
var staticRenderFns = []

export { render, staticRenderFns }